import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpManagerService}  from '../../api/httpmanager.service';


@Injectable()
export class HiringService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allHiring(): Promise<any> {
        return this.httpmanagerService.HttpGet('hiring', "").then(function (data) {
            return data.data;
        });
    }
    iHiring(app): Promise<any> {
        return this.httpmanagerService.HttpPost('hiring', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }
    uHiring(id, data): Promise<any> {
        return this.httpmanagerService.HttpPut('hiring', JSON.stringify(data), id).then(function (data) {
            return data;
        });
    }
    uHiringindex(app): Promise<any> {
        return this.httpmanagerService.HttpPost('hiring/updateindex', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }
    dHiring(id): Promise<any>{
        return this.httpmanagerService.HttpDelete('hiring',id).then(data =>{
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/hiring/hiring.service.ts